export enum PartyTypes {
  reservation = 2,
  walkIn,
  order = 7,
  togo = 8,
}
